//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalGeneric',
  data() {
    return {
      title: '',
      content: ''
    }
  },
  mounted() {
    window.addEventListener('message', message => {
        if(_.includes(message.data, 'close')) {
          this.close();
        }
    });
  },
  methods: {
    beforeOpen (event) {console.info(event)
      window.dispatchEvent(new Event('resize'));

      this.title = _.get(event, 'params.title', '')
      this.content = _.get(event, 'params.content', '')
    },
    close() {
      this.$modal.hide('modal-generic')
    },
    async submit() {}
  }
}
